<template>
  <div
    class="ctx"
    :style="{ backgroundImage: `url(${info.cover ? info.cover : ''})` }"
  >
    <div class="content">
      <div class="banner">
        <img src="" v-if="info.banner" />
      </div>
      <a :href="info.url" class="live-link"></a>
      <div class="like-area">
        <like
          :title="info.img_title"
          :id="info.id"
          v-if="info.img_title"
        ></like>
      </div>
      <div class="live-info" :style="{ color: colors.mainColor }">
        <div class="live-time">直播时间：{{ info.showTime }}</div>
        <!--                <div class="live-lot" v-if="info.lottery_alias" @click="showLot">-->
        <!--                    <div class="lot-icon iconfont">&#xeac7;</div>-->
        <!--                    <div class="lot-txt">抽奖</div>-->
        <!--                </div>-->
      </div>
      <div class="live-other" v-html="info.tab" v-if="info.tab"></div>
    </div>
    <!--        <lottery :show="show" :sub="sub" @close="show=false" :lot-num="info.lottery.id" v-if="info.lottery && info.lottery.id"></lottery>-->
  </div>
</template>

<script>
// import lottery from "../components/lottery";
import { wxConf } from "../common/wxTool";
import { getDate } from "../common/tool";
// import {getToken} from "../common/storage";
import { getSub } from "../common/auth";
import like from "../components/like";

export default {
  name: "Page",
  components: {
    // lottery,
    like,
  },
  data() {
    return {
      show: false,
      // sub: getToken().subscribe,
      info: {},
      colors: {},
    };
  },
  mounted() {
    this.getLiveInfo();
  },
  methods: {
    showLot() {
      getSub((sub) => {
        this.sub = sub;
        this.show = true;
      });
    },
    getLiveInfo() {
      let alias = this.$route.params.alias;
      this.$axios({
        url: "/activity-live?filter[alias]=" + alias,
      }).then((res) => {
        // this.dealInfo(res);
        if (res.data && res.data.length > 0) {
          this.dealInfo(res.data[0]);
        }
      });
    },
    dealInfo(info) {
      document.title = info.title;
      let start = getDate(info.start_time);
      info.showTime = start.pattern("MM月dd日 HH:mm");
      let color = info.color;
      if (color) {
        if (color.startsWith("#")) {
          this.colors = {
            mainColor: color,
          };
        } else {
          this.colors = JSON.parse(color);
        }
      }
      if (info.lottery_alias) {
        try {
          info.lottery = JSON.parse(info.lottery_alias);
        } catch (e) {
          console.error(e);
        }
      }
      this.info = info;
      this.init();
    },
    init() {
      this.wxInit();
    },
    wxInit() {
      let info = this.info;
      let imgUrl =
        info.share_logo ||
        "https://zk-static-1301841918.cos.ap-nanjing.myqcloud.com/tencent.jpg";
      let title = info.share_title || info.title;
      let desc = info.share_desc || info.title;
      wxConf(title, desc, imgUrl);
    },
  },
};
</script>

<style scoped lang="less">
.ctx {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: center top no-repeat;
  background-size: cover;
}
.live-link {
  display: block;
  margin: 40px 50px;
  height: 360px;
  background: url(https://zk-static-1301841918.cos.ap-nanjing.myqcloud.com/topic/live_play.jpg)
    center no-repeat;
  background-size: cover;
}
.like-area {
  padding: 0 20px;
}
.live-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  padding: 0 50px;
  font-size: 28px;
}
.live-lot {
  display: flex;
  align-items: center;
}
.lot-icon {
  width: 40px;
  height: 40px;
  line-height: 40px;
  font-size: 40px;
}
.lot-txt {
  margin-left: 10px;
}
.live-other {
  margin-top: 60px;
  padding: 0 50px;
}
</style>
